import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Device from "./Device";
import ManualDeviceInfo from "./ManualDeviceInfo";
import { DeviceData } from "../models/DeviceData";
import ManualActionDevice from "./ManualActionDevice";
import { Message } from "../models/ProtectiveFunctionWrapper";

interface Props {
    zoom: number;
    devices: Array<DeviceData>;
    handleDeviceClicked: (device: DeviceData, type: string) => void;
    handleManualActionDeviceRightClicked: (e: React.MouseEvent) => void;
    errorsAndWarnings: Message[];
}

export class ManualActionConfiguration extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    zoom(value: number, unit: "px" | "em") {
        return `${value * this.props.zoom}${unit}`;
    }

    render() {
        const handleManualActionDeviceRightClicked = this.props.handleManualActionDeviceRightClicked;
        const handleDeviceClicked = this.props.handleDeviceClicked;
        const zoom = this.props.zoom;
        const boxSize = this.zoom(50, "px");
        const imgWidth = this.zoom(48, "px");
        const imgHeight = this.zoom(41, "px");
        const deviceX = this.zoom(27, "px");
        const deviceY = this.zoom(43, "px");
        const infoX = this.zoom(4, "px");
        const infoY = this.zoom(100, "px");

        const fontSize = this.zoom(.9, "em");

        var errorsAndWarnings: Message[] = [];
        if (this.props.errorsAndWarnings && this.props.devices[0]) {
            errorsAndWarnings = this.props.errorsAndWarnings.filter(x => x.messageItems ? x.messageItems.some(c => this.props.devices.map(x => x.ptProtectiveFunction.guiLocation).some(d => c.id === d)) : false);
        }

        return (
          <div className="support_manual_action" onClick={(event: React.MouseEvent) => this.props.handleDeviceClicked(this.props.devices[0], "ManualActionDevice")} onContextMenu={(e: React.MouseEvent) => this.props.handleManualActionDeviceRightClicked(e)}>
                {/* Channel 1 */}
                <ManualDeviceInfo x={infoX} y={infoY} fontSize={fontSize} device1={this.props.devices[0]} />
                <ManualActionDevice type={"ManualActionDevice"} x={deviceX} y={deviceY} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={errorsAndWarnings} device={this.props.devices[0]} handleDeviceClicked={handleDeviceClicked} handleManualActionDeviceRightClicked={handleManualActionDeviceRightClicked}/>

                {/* Background */}
                <img style={{ width: `${100 * zoom}px`, height: `${100 * zoom}px` }} src={`/HTMLImages/Elements/Manual_Image.png`} />
            </div>
        );
    }
}